/**
 * Constant tên form tham số báo cáo, 
 * đưa ra đây để nếu ai sửa thì chỉ cần sửa 1 chỗ
 */
export default {
  ReportParamC40BB : 'ReportParamC40BB',
  ReportParamC41BB : 'ReportParamC41BB',
  ReportParam_C37HD : 'ReportParam_C37HD',
  ReportParam_C37HD_Detail : 'ReportParam_C37HD_Detail',
};
